import React from 'react'
//import './style.css'
import {Validators} from "../../../../components/_common/_form/Validators/index"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack/index"
import NRTFormInput from "../../../../components/_common/_form/FormInput/index"
import NRTHorizontalStack from "../../../../components/_common/_containers/HorizontalStack/index"
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager/index"
import PropTypes from 'prop-types'
import MCEadInputLabel from "../../../../components/_ead/InputLabel"

const THEME_COLORS = [
    '#e74c3c',
    '#ff3838',
    '#ee5253',
    '#eb3b5a',
    '#fa8231',
    '#ffaf40',
    '#f1c40f',
    '#fbc531',
    '#ffd32a',
    '#218c74',
    '#44bd32',
    '#2ecc71',
    '#2ed573',
    '#192a56',
    '#273c75',
    '#40739e',
    '#487eb0',
    '#0097e6',
    '#00a8ff',
    '#706fd3',
    '#8e44ad',
    '#9b59b6',
    '#e84393',
    '#f368e0',
    '#000',
    '#212121',
    '#2f3640',
    '#7f8c8d',

]


const TabBasicConfig = (props) => {


    const {
        onConfigChange,
        systemConfigParameterValue
    } = props


    return (


        <NRTFormStateManager onStateChange={(form) => {
            if (!form.dirty)
                return

            onConfigChange(form.values)
        }}>
            <NRTVerticalStack>
                <NRTFormInput label={'Habilitar Área Pública'}
                              name={'publicArea'}
                              value={systemConfigParameterValue.publicArea}
                              type={'switch'}
                              switchType={'primary'}
                />

                 <NRTFormInput label={'Exibir informações do instrutor'}
                               name={'authorInfo'}
                               value={systemConfigParameterValue.authorInfo}
                               type={'switch'}
                               switchType={'primary'}
                />

                <NRTFormInput
                    label={'Título*'}
                    name={'title'}
                    value={systemConfigParameterValue.title}
                    validators={[Validators.minLengthValidator(3)]}
                />

                <NRTHorizontalStack fractions={[1, 1]}>
                    <NRTFormInput
                        label={'Logo'}
                        name={'logo'}
                        type={'file'}
                        value={systemConfigParameterValue.logo}
                        customClass={'nrt-file-input-container'}
                        customProps={{
                            shouldUploadToS3: true,
                            s3ParentType: 'Configuracao/minhacentral/logo'
                        }}
                    />
                    <NRTFormInput
                        label={'Imagem de fundo (Login)'}
                        name={'loginBackground'}
                        type={'file'}
                        value={systemConfigParameterValue.loginBackground}
                        customClass={'nrt-file-input-container'}
                        customProps={{
                            shouldUploadToS3: true,
                            s3ParentType: 'Configuracao/minhacentral/login'
                        }}
                    />
                </NRTHorizontalStack>



                <NRTHorizontalStack fractions={[1, 1]}>
                    <NRTFormInput
                        label={'Cor Principal'}
                        name={'primaryColor'}
                        value={systemConfigParameterValue.primaryColor}
                        validators={[
                            // Validators.minLengthValidator(3)
                        ]}
                        customProps={{
                            colors: THEME_COLORS
                        }}
                        type={'color'}

                    />

                    <NRTFormInput
                        label={'Cor Secundária'}
                        name={'secondaryColor'}
                        value={systemConfigParameterValue.secondaryColor}
                        validators={[
                            // Validators.minLengthValidator(3)
                        ]}
                        customProps={{
                            colors: THEME_COLORS
                        }}
                        type={'color'}

                    />

                </NRTHorizontalStack>
            </NRTVerticalStack>
        </NRTFormStateManager>

    )
}


TabBasicConfig.propTypes = {
    onConfigChange: PropTypes.func.isRequired,
    systemConfigParameterValue: PropTypes.object.isRequired,
}

TabBasicConfig.defaultProps = {}

export default TabBasicConfig



// WEBPACK FOOTER //
// ./src/_pages/Admin/_partials/TabBasicConfig/index.js